/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import {
  QueryClient,
  QueryFunctionContext,
  QueryKey,
} from "@tanstack/react-query";
import { GramCore } from "../core.js";
import { pluginsListPlugins } from "../funcs/pluginsListPlugins.js";
import { combineSignals } from "../lib/primitives.js";
import { RequestOptions } from "../lib/sdks.js";
import { ListPluginsResult } from "../models/components/listpluginsresult.js";
import {
  ListPluginsRequest,
  ListPluginsSecurity,
} from "../models/operations/listplugins.js";
import { unwrapAsync } from "../types/fp.js";
export type PluginsQueryData = ListPluginsResult;

export function prefetchPlugins(
  queryClient: QueryClient,
  client$: GramCore,
  request?: ListPluginsRequest | undefined,
  security?: ListPluginsSecurity | undefined,
  options?: RequestOptions,
): Promise<void> {
  return queryClient.prefetchQuery({
    ...buildPluginsQuery(
      client$,
      request,
      security,
      options,
    ),
  });
}

export function buildPluginsQuery(
  client$: GramCore,
  request?: ListPluginsRequest | undefined,
  security?: ListPluginsSecurity | undefined,
  options?: RequestOptions,
): {
  queryKey: QueryKey;
  queryFn: (context: QueryFunctionContext) => Promise<PluginsQueryData>;
} {
  return {
    queryKey: queryKeyPlugins({
      gramSession: request?.gramSession,
      gramProject: request?.gramProject,
    }),
    queryFn: async function pluginsQueryFn(ctx): Promise<PluginsQueryData> {
      const sig = combineSignals(
        ctx.signal,
        options?.signal,
        options?.fetchOptions?.signal,
      );
      const mergedOptions = {
        ...options?.fetchOptions,
        ...options,
        signal: sig,
      };

      return unwrapAsync(pluginsListPlugins(
        client$,
        request,
        security,
        mergedOptions,
      ));
    },
  };
}

export function queryKeyPlugins(
  parameters: {
    gramSession?: string | undefined;
    gramProject?: string | undefined;
  },
): QueryKey {
  return ["@gram/client", "plugins", "listPlugins", parameters];
}
